import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBolt, FaBookOpen, FaCogs, FaListUl } from 'react-icons/fa';
import { THEME_DATA } from './themeSearchWords'; // ??????? ??????? ?????? ?? WordSearch

const PUZZLE_TYPES = [
  'Sudoku', 'Maze', 'WordSearch', 'Math', 
  'WordScramble', 'NumberPyramid', 'Bingo', 
  'Crossword', 'Snakes', 'Jigsaw'
];

const AutoGenerator = ({ onAddBulk }) => {
  const navigate = useNavigate();
  const [isGenerating, setIsGenerating] = useState(false);
  const [selectedType, setSelectedType] = useState('Sudoku');

  const [counts, setCounts] = useState({
    easy: 40,
    medium: 60,
    hard: 50,
    expert: 0
  });

  const handleCountChange = (e) => {
    setCounts({ ...counts, [e.target.name]: parseInt(e.target.value) || 0 });
  };

  const totalPuzzles = Object.values(counts).reduce((a, b) => a + b, 0);

  const handleGenerateBook = async () => {
    if (totalPuzzles === 0) {
        alert("Please select at least 1 puzzle to generate!");
        return;
    }

    // ? ??? ????? ?? WordSearch: ???? ?? ??????? ????? ?? ?????
    if (selectedType === 'WordSearch' && THEME_DATA.length < totalPuzzles) {
        alert(`You only have ${THEME_DATA.length} themes in your file. You need ${totalPuzzles} for this book.`);
        return;
    }

    setIsGenerating(true);
    const newPages = [];
    const difficulties = ['easy', 'medium', 'hard', 'expert'];
    
    let themeIndex = 0; // ???? ??? ??? ?? WordSearch

    for (let diff of difficulties) {
        const count = counts[diff];
        if (count > 0) {
            for (let i = 0; i < count; i++) {
                const uniqueId = Date.now().toString(36) + Math.random().toString(36).substring(2, 9);
                const numericSeed = Math.floor(Math.random() * 900000000) + 100000000 + i;
                
                // ? ?????? ?????? ?? WordSearch:
                let currentWords = 'REACT,CODE,JAVA,HTML'; // ????????? ????? ???????
                if (selectedType === 'WordSearch') {
                    currentWords = THEME_DATA[themeIndex]; // ?? ????? ??????? ?? ?????
                    themeIndex++;
                }

                const settings = { 
                    difficulty: diff, 
                    size: 20, 
                    words: currentWords, 
                    seed: numericSeed 
                };
                
                newPages.push({
                    type: selectedType,
                    settings: settings,
                    seed: numericSeed,
                    id: uniqueId
                });
            }
        }
    }

    await new Promise(r => setTimeout(r, 800));
    onAddBulk(newPages);
    setIsGenerating(false);
    navigate('/my-book'); 
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}><FaBolt style={{color: '#f1c40f'}} /> Auto Book Generator</h1>
      <p style={styles.subtitle}>
        Create a highly targeted KDP niche book instantly. Choose one game type, set the difficulty levels, and generate!
      </p>

      <div style={styles.card}>
        <h3 style={styles.cardTitle}><FaCogs /> 1. Select Game Type</h3>
        <select value={selectedType} onChange={(e) => setSelectedType(e.target.value)} style={styles.select}>
            {PUZZLE_TYPES.map(type => (
                <option key={type} value={type}>{type} Puzzle {type === 'WordSearch' ? ' (Theme Mode)' : ''}</option>
            ))}
        </select>
        
        {/* ? ????? ???????? ??? ????? WordSearch */}
        {selectedType === 'WordSearch' && (
          <div style={{marginTop: '10px', fontSize: '13px', color: '#27ae60', display: 'flex', alignItems: 'center', gap: '5px'}}>
            <FaListUl /> <strong>{THEME_DATA.length}</strong> Themes loaded from themeSearchWords.js
          </div>
        )}
      </div>

      <div style={styles.card}>
        <h3 style={styles.cardTitle}><FaBookOpen /> 2. Set Difficulty Distribution</h3>
        <div style={styles.grid}>
          {Object.keys(counts).map(diff => (
            <div key={diff} style={styles.inputWrapper}>
              <label style={{...styles.label, color: getDiffColor(diff)}}>{diff.toUpperCase()}</label>
              <input type="number" name={diff} value={counts[diff]} onChange={handleCountChange} min="0" max="200" style={styles.input} />
            </div>
          ))}
        </div>
      </div>

      <div style={styles.footer}>
        <div style={styles.summary}>Total Puzzles: <strong>{totalPuzzles}</strong> Pages</div>
        <button onClick={handleGenerateBook} disabled={isGenerating || totalPuzzles === 0} style={styles.button}>
          {isGenerating ? '? Generating Themes...' : '?? Generate Book Now'}
        </button>
      </div>
    </div>
  );
};

// ??????? ?????????? (?????? ?????? ?????)
const getDiffColor = (diff) => {
    switch(diff) {
        case 'easy': return '#27ae60';
        case 'medium': return '#f39c12';
        case 'hard': return '#e74c3c';
        case 'expert': return '#8e44ad';
        default: return '#2d3436';
    }
}

const styles = {
  container: { padding: '30px', maxWidth: '700px', margin: '0 auto', fontFamily: "'Segoe UI', sans-serif" },
  title: { textAlign: 'center', color: '#2d3436', marginBottom: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 },
  subtitle: { textAlign: 'center', color: '#636e72', marginBottom: '40px', fontSize: '15px' },
  card: { background: 'white', padding: '25px', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', border: '1px solid #eee', marginBottom: '20px' },
  cardTitle: { display: 'flex', alignItems: 'center', gap: '8px', marginTop: 0, marginBottom: 15, color: '#2d3436', borderBottom: '1px solid #eee', paddingBottom: 10, fontSize: '18px' },
  select: { width: '100%', padding: '12px', fontSize: '16px', borderRadius: '8px', border: '2px solid #0984e3', outline: 'none', cursor: 'pointer', background: '#f8f9fa', fontWeight: 'bold' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '15px' },
  inputWrapper: { display: 'flex', flexDirection: 'column', alignItems: 'center', background: '#f8f9fa', padding: '15px', borderRadius: '8px', border: '1px solid #dfe6e9' },
  label: { fontWeight: '900', marginBottom: '10px', fontSize: '14px', letterSpacing: '1px' },
  input: { width: '80%', padding: '10px', fontSize: '18px', textAlign: 'center', borderRadius: '6px', border: '1px solid #b2bec3', outline: 'none' },
  footer: { marginTop: '40px', textAlign: 'center' },
  summary: { fontSize: '18px', color: '#2d3436', marginBottom: '20px', background: '#e1fbef', padding: '10px 20px', display: 'inline-block', borderRadius: '30px', border: '1px solid #a3e4d7' },
  button: { width: '100%', color: 'white', background: '#0984e3', padding: '18px 40px', fontSize: '20px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', boxShadow: '0 5px 15px rgba(9, 132, 227, 0.3)', transition: 'all 0.3s ease' }
};

export default AutoGenerator;